module.exports = __webpack_public_path__ + "static/media/photo95.22255e2c.jpg";